import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import isEqual from 'lodash.isequal';
import { getProfilePermissions } from 'b2b-apps/shop/context/redux/selectors';
import { hasPermissions } from 'b2b-apps/shop/context/utils/permissions';

export type UsePermissionsValidatorReturnType = (permissionsRequired: string[]) => boolean;

export const usePermissionsValidator = (): UsePermissionsValidatorReturnType => {
  const debitorPermissions = useSelector(getProfilePermissions, isEqual);

  return useCallback(
    (permissionsRequired: string[]) => hasPermissions(permissionsRequired, debitorPermissions),
    [debitorPermissions],
  );
};
